import { RootState } from '../store';
import { SnackbarState } from './slice';

export const getSnackbars = (state: RootState): SnackbarState['snackbars'] => state.snackbar.snackbars;
